/**
 * canAccessBids (ticket #295)
 * The one check for the Bids workspace: routes, nav items, the workspace
 * switch and bid rehydration all call this. Pilot = super-admins only, behind
 * the REACT_APP_FEATURE_BIDS build flag. A future bids role changes only this.
 *
 * @param {{ isSuperAdmin?: boolean }} auth - the auth context values
 * @returns {boolean}
 */
export const canAccessBids = (auth) =>
  !!auth?.isSuperAdmin && process.env.REACT_APP_FEATURE_BIDS === 'true';
